import React, { Component } from 'react';
import ReactMarkdown from 'react-remarkable';
import articleService from '../../services/article';
import languageService from '../../services/language';
import throttle from 'lodash.throttle';
import $ from 'jquery';
import './index.css';

const language = languageService.language;

export default class Articles extends Component {
  state = {
    articles: [],
    limit: 10,
    skip: 0
  };

  constructor(props) {
    super(props);

    this.onScroll = throttle(this.onScroll.bind(this), 500);
  }

  fetchArticles() {
    if (this.props.articles) {
      console.log('fetchArticles', this.props.articles, this.state.articles, this.state.skip, this.state.limit);
      let query = {'alternativeId': this.props.articles};

      query.limit = this.state.limit;
      query.skip = this.state.skip;

      return articleService.dataWithQuery(query)
      .then(this.pushUpdateFieldInState.bind(this, 'articles'))
      .then(() => {
        this.setState({
          skip: this.state.skip + this.state.limit
        });
      })
      .catch(this.showErr.bind(this));
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.onScroll);

    this.fetchArticles();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps && nextProps.articlesFull) {
      this.updateFieldInState('articles', nextProps.articlesFull);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll);
  }

  onScroll(event) {
    if ($(window).scrollTop() + $(window).height() > $(document).height() - 200) {
      this.fetchArticles();
    }
  }

  showErr(error) {
    console.error(error);
  }

  pushUpdateFieldInState(field, value) {
    if (value) {
      value = value
      .map(article => Object.assign({}, article, {expanded: false}))
      .filter(article => {
        let ok = true;

        this.state[field].forEach(a => {
          if (a.id === article.id) {
            ok = false;
          }
        });

        return ok;
      });
    }

    this.setState({
      [field]: (this.state[field] || []).concat(value)
    });
  }

  updateFieldInState(field, value) {
    if (value) {
      value = value.map(article => Object.assign({}, article, {expanded: false}));
    }

    this.setState({
      [field]: value
    });
  }

  expandArticle(id) {
    const articles = this.state.articles.map(article => {
      if (article.id === id) {
        article.expanded = !article.expanded;
      }

      return article;
    });

    this.setState({
      articles: articles
    });
  }

  renderContent() {
    return this.state.articles
    .map((article, index) => {
      const toggleIcon = article.expanded ? <i className="fa fa-chevron-up" /> : <i className="fa fa-chevron-down" />;
			let content = null;

			if (article.expanded) {
				if (article[`content${language}`].indexOf('VIDEO') !== -1) {
					const video = article[`content${language}`].replace('VIDEO', '');

					content = (
						<div className="comp-articles__article__content">
							<iframe src={`https://www.youtube.com/embed/${video}`} allowFullScreen></iframe>
						</div>
					);
				} else {
					content = (
						<div className="comp-articles__article__content">
							<ReactMarkdown source={article[`content${language}`]} />
						</div>
					);
				}
			}

      return (
        <div className="comp-articles__article item-with-box-shadow col-md-12" id={article.alternativeId} key={`article-${index}`}>
          <h5 className="comp-articles__article__title">
            {article[`title${language}`]}
          </h5>

          <h6 className="u-m-t-5">{article[`secondTitle${language}`] || '—'}</h6>

          {content}

          <div className="toggle" onClick={this.expandArticle.bind(this, article.id)}>
            {toggleIcon}
          </div>
        </div>
      );
    });
  }

  render() {
    let rendered = null;

    if (this.state.articles) {
      rendered = this.renderContent();
    }

    return (
      <div className="comp-articles row">
        {rendered}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/articles/index.js